import { styled } from 'styled-components';
import { IconX } from '@tabler/icons-react';

export const StyledXIcon = styled(IconX)`
    height: 20px;
    width: 20px;
    color: ${({ theme }) => theme.colors.grayscale.gray7};
`;
